import { render } from "./ImagePreview.vue?vue&type=template&id=c15ea0c8&scoped=true"
import script from "./ImagePreview.vue?vue&type=script&lang=js"
export * from "./ImagePreview.vue?vue&type=script&lang=js"

import "./ImagePreview.vue?vue&type=style&index=0&id=c15ea0c8&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c15ea0c8"]])

export default __exports__